import { useStore, useDispatch } from 'react-redux';
import { useState, useEffect, useMemo } from 'react';
import G from './Getters';
import A from './ActionCreators';
import { ColumnResizeContext, CellResizeContext } from './Contexts';


export default function ColumnResizeProvider({children, figurePanelId}){
  let dispatch = useDispatch();

  //const [adjustmentSide,setAdjustmentSideContext] = useState();
  const [cellResizeInfo, setCellResizeInfo ] = useState();
  const [columnResizeInfo,setColumnResizeInfo] = useState();

  let store = useStore();
  let state = store.getState();

  let widths = G.getColumnsWidths(state,{figurePanelId})
  const [ currentWidths, _setCurrentWidths ] = useState(widths);

  const setCurrentWidths = value => {

    console.log("toSet",value);
    console.log("crVal",currentWidths);


    if( value.some((v,ii) => {
      return Math.abs(v-currentWidths[ii]) > 10
    })){
      //debugger;
    }



    _setCurrentWidths(value);
  }

  useEffect(() => {
    setCurrentWidths(widths);
  },[widths])


  useEffect(() => {

    function mouseUp(e){

      if( cellResizeInfo ){

        let cellsToSet = currentWidths.map((_,ii) => ([0,ii]))

        dispatch(
          A.setCellWidths({
            figurePanelId,
            cellsToSet,
            widths:currentWidths
          })
        )

        setCellResizeInfo();
        //setAdjustmentSideContext();



        const findIfHoveringColumnResize = () => {

          let hoveredElementsByMouse = document.querySelectorAll(":hover");
          let widthResizerClassName = ('cell-width-resizer-element')
          let isHoveringResize = Array.from(hoveredElementsByMouse).find(ele => ele.className?.includes?.(widthResizerClassName));

          return isHoveringResize;
        };

        let isHoveringColumnResize = findIfHoveringColumnResize();

        if( !isHoveringColumnResize ){
          setColumnResizeInfo();
        }

        console.log("ON MOUSE UP!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");

        //setCurrentWidths(null);

        //setCropIdsBeingDragged([]);



        return;

      }
    }
    window.addEventListener('mouseup',mouseUp);

    return () => {
      window.removeEventListener('mouseup',mouseUp);
    }

  })

  const columnResizeContext = useMemo(() => ({
    columnResizeInfo,
    setColumnResizeInfo, 
    setCurrentWidths,
    currentWidths
  }),[columnResizeInfo,setColumnResizeInfo,setCurrentWidths, currentWidths])

  const cellResizeContext = useMemo(() => ({
    cellResizeInfo,
    setCellResizeInfo
  }),[cellResizeInfo,setCellResizeInfo])

  //console.log("currentWidths",currentWidths);


  return (

    <CellResizeContext.Provider value={cellResizeContext}>
    <ColumnResizeContext.Provider value={columnResizeContext}>
      {children}
      {true && <div style={{
        position:'absolute',
        bottom:0,
        left:0,
        background:'black'
      }}>
        
      </div>}
    </ColumnResizeContext.Provider>
    </CellResizeContext.Provider>

  )


}
